import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { AvoTrackingService } from "@bca-core/services/avo-tracking.service";
import * as appActions from "@bca-store/app.actions";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";

@Component({
  selector: "ns-product-info",
  templateUrl: "product-info.component.html",
  styleUrls: ["product-info.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductInfoComponent implements OnInit {
  @Input()
  insideTile: boolean;
  @Input()
  maxBuyableProducts: number;
  @Input()
  showPhone: boolean;

  @Output()
  action = new EventEmitter<
    appActions.ShowPhone | appActions.DownloadApplicationForm
  >();

  externalFormNlURL: "https://www.ns.nl/zakelijk/formulieren/aanvragen-overeenkomst-ns-business-cards";
  externalFormEngURL: "https://www.ns.nl/en/business/forms/request-agreement-ns-business-cards";
  convertedMaxBuyableProducts$: Observable<string>;

  constructor(
    private _translate: TranslateService,
    private _avoTrackingService: AvoTrackingService,
  ) {}

  ngOnInit(): void {
    this.convertedMaxBuyableProducts$ = this._translate.get(
      "RECEIPT.MORE_CARDS.AMOUNT." + this.maxBuyableProducts,
    );
  }

  phoneClick(): void {
    this.action.emit(new appActions.ShowPhone());
  }

  goToDownloadForm(): void {
    // just here and not all the parents
    let formUrl: string;
    const lang = this._translate.currentLang;

    if (lang === "en") {
      formUrl = this.externalFormEngURL;
    } else {
      formUrl = this.externalFormNlURL;
    }

    this._avoTrackingService.trackDownloadFormLinkClick(formUrl);
    this.action.emit(new appActions.DownloadApplicationForm());``
  }
}
